import { ElementType, ReactElement } from 'react';

import { ChipTypeMap } from '@mui/material/Chip';

import BaseStyledAutocomplete from './components/base-styled-autocomplete/base-styled-autocomplete';
import { BaseAutocompleteProps } from './models/base-autocomplete.props';

const BaseAutocomplete = <
  Entity,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
  ChipComponent extends ElementType = ChipTypeMap['defaultComponent']
>(
  props: BaseAutocompleteProps<
    Entity,
    Multiple,
    DisableClearable,
    FreeSolo,
    ChipComponent
  >
): ReactElement => {
  return (
    <BaseStyledAutocomplete className={'dropdown-autocomplete'} {...props} />
  );
};

export default BaseAutocomplete;
